@if (spinner) {
  <app-spinner></app-spinner>
}

<div class="inner-page-header">
  <div class="titles">
    <h3 class="title">لوحة التحكم</h3>
  </div>
</div>

<div class="dashboard-content">
  <div class="dashboard-stats">
    <div class="stat-card">
      <p class="stat-value blue">{{ openQuestionsCount }}</p>
      <p class="stat-label">الاسئلة المفتوحة</p>
    </div>
    <div class="stat-card">
      <p class="stat-value orange">{{ needReviewCount }}</p>
      <p class="stat-label">المراجعة الادارية</p>
    </div>
    <div class="stat-card">
      <p class="stat-value green">{{ activeCohortName }}</p>
      <p class="stat-label">المجموعة النشطة</p>
    </div>
  </div>

  <h4 class="dashboard-section-title">الاجراءات</h4>

  <div class="dashboard-actions">
    @for (action of actions; track action.title) {
      <div
        class="action-card"
        [class.disabled]="!action.route"
        (click)="goToAction(action)"
      >
        @if (!action.route) {
          <span class="coming-soon-badge">قريباً</span>
        }
        <div class="action-body">
          <div class="action-icon">
            <img [src]="action.icon" alt="" />
          </div>
          <div class="action-text">
            <p class="action-title">{{ action.title }}</p>
            <p class="action-description">{{ action.description }}</p>
          </div>
        </div>
      </div>
    }
  </div>
</div>
